module.exports = {"610427001":"城关街道","610427101":"北极镇","610427102":"新民镇","610427103":"龙高镇","610427105":"永乐镇","610427106":"义门镇","610427107":"水口镇","610427108":"韩家镇","610427109":"太峪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610427.json
// module id = 2814
// module chunks = 0